import React, { ReactElement } from 'react';
import { Alert, Stack } from '@efast_public/fjd-component-library';
import { Link } from 'react-router-dom';
import { RoutePaths } from '../AppRoutes';

export default function EmptySchreibtischNoAntraege(): ReactElement {
  return (
    <React.Fragment>
      <Stack direction="row" spacing="xs">
        <Alert
          message="Derzeit liegen keine Anträge vor."
          variant="info"
          key="alert-keineAntraegeVorhanden"
          data-testid="alert-keineAntraegeVorhanden"
        >
          <Link key={'link-antragsuebersicht'} to={RoutePaths.ANTRAEGE}>
            Zur Antragsübersicht
          </Link>
        </Alert>
      </Stack>
    </React.Fragment>
  );
}
